import { APIAdminClient } from '@core/typings/api/admin-client.typing';
import { SimpleNumberMap } from '@yourcause/common';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class ProgramFormsState extends BaseYcState {
  readonly programFormsMap: SimpleNumberMap<APIAdminClient.GrantProgramForm[]> = {};
}
